// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Wo-z","breadcrumbForward":"Xo-z","breadcrumbBack":"Yo-z","selected":"Zo-z"};